import React, { useState, useEffect } from 'react';
import { useParams, useSearchParams, useLocation } from "react-router";

import ProfileFetch from '../../fetch/profileFetch';

import ProfileEditorViewer from "./ProfileEditorViewer";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import profileFetch from "../../fetch/profileFetch";

function ProfileEditor()  {
    const _ = require('lodash');

    const [alertMessage, setAlertMessage] = useState("");
    const [editMode, setEditMode] = useState(false);
    const [profile, setProfile] = useState(null);
    const [editedProfile, setEditedProfile] = useState(null);
    const [investorMode, setInvestorMode] = useState(true);
    const [fundings, setFundings] = useState([]);
    const [fundingsFetched, setFundingsFetched] = useState(false);
    const [fundingsFetchError, setFundingsFetchError] = useState(false);

    const [searchParams] = useSearchParams();
    const { orgId } = useParams();
    const location = useLocation();

    const updateEditedProfile = (field, value) => {
        let profileCopy = _.cloneDeep(editedProfile);
        _.set(profileCopy, field, value);
        setEditedProfile(profileCopy)
    }

    const onSave = () => {
        ProfileFetch.updateEntity(editedProfile).then(newProfile=>{
            setEditedProfile(newProfile);
            setProfile(newProfile);
        });
        setEditMode(false);

    }

    useEffect(() => {
        let localInvestorMode = !location.pathname.startsWith("/company");
        setInvestorMode(localInvestorMode);

        ProfileFetch.getProfile(orgId).then(response=>{
            setProfile(response);
            setEditedProfile(response);
        }).catch(err => {
            setAlertMessage("Error fetching profile. Please try again in a few minutes.")
        });

        if (localInvestorMode) {
            ProfileFetch.getInvestments(orgId).then(response=>{
                setFundings(response);
                setFundingsFetched(true);
                setFundingsFetchError(false);
            }).catch(err => {
                setAlertMessage("Error fetching investments. Please try again in a few minutes.")
                setFundingsFetched(true);
                setFundingsFetchError(true);
            });
        } else {
            ProfileFetch.getFundings(orgId).then(response=>{
                setFundings(response);
                setFundingsFetched(true);
                setFundingsFetchError(false);
            }).catch(err => {
                setAlertMessage("Error fetching fundings. Please try again in a few minutes.")
                setFundingsFetched(true);
                setFundingsFetchError(true);
            });
        }

        const eventDomain = localInvestorMode ? "investorEditor" : "companyEditor";
        const event = {
            eventKey: `${eventDomain}.pageView`,
            url: window.location.pathname,
            details: {
                campaignId: searchParams.get('campaignId'),
                campaignName: searchParams.get('campaignName'),
            }
        }
        profileFetch.recordEvent(event, orgId).then(response=>{}).catch(err => {});

    }, [orgId, searchParams, location.pathname]);

    const reloadFundings = (fundings) => {
        if (investorMode) {
            ProfileFetch.getInvestments(orgId).then(response=>{
                setFundings(response);
            }).catch(err => {
                setAlertMessage("Error fetching investments. Please try again in a few minutes.")
            });
        } else {
            setFundings(fundings);
        }
    }

    if (!profile || !fundings) {
        return (
            <div/>
        )
    }

    return (
        <div>
            <ProfileEditorViewer
                profile={editedProfile}
                fundings={fundings}
                fundingsFetched={fundingsFetched}
                fundingsFetchError={fundingsFetchError}
                setEditMode={setEditMode}
                editMode={editMode}
                updateEditedProfile={updateEditedProfile}
                onSave={onSave}
                orgId={orgId}
                onFundingsUpdated={reloadFundings}
                investorMode={investorMode}
                setAlertMessage={setAlertMessage}
            />
            <Snackbar open={alertMessage !== ""} autoHideDuration={6000} onClose={()=>{setAlertMessage("")}}>
                <Alert
                    onClose={()=>{setAlertMessage("")}}
                    severity="warning"
                    sx={{ width: '100%' }}
                    anchorOrigin={ { vertical: 'bottom', horizontal: 'center' } }
                >
                    {alertMessage}
                </Alert>
            </Snackbar>
        </div>
    )
}

export default ProfileEditor;

